import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { TemplateDesignElement } from '../../design-element';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  MassNotificationTemplate,
  MessageSettings,
  ConfirmationType
} from 'src/app/modules/communications/store/communications';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';

@Component({
    selector: 'app-tts-confirmation-question',
    templateUrl: './tts-confirmation-question.component.html',
    styleUrls: ['./tts-confirmation-question.component.scss'],
    standalone: false
})
export class TtsConfirmationQuestionComponent implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() messageSettings?: MessageSettings;
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this._culture = value;
    if (!this.editMode && !!value) {
      this.render();
    }
  }
  _culture: string;
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();

  editMode: boolean;
  confirmationText: string;
  confirmationButtons: any[];
  ConfirmationType = ConfirmationType;

  constructor(private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  loadSettings(): void {
    this.editMode = true;
  }

  saveSettings(): boolean {
    return true;
  }

  render(): void {
    this.confirmationButtons = this.messageSettings?.confirmationButtons?.map((b, i) => {
      return {
        index: i + 1,
        text: this.templateDesignerService.getTranslateText(b.text, this._culture),
        type: b.type
      };
    });

    this.editMode = false;
  }

  edit(): void {}

  setRuntimeData(data: any): void {}
}
